import { render } from "./CaptureModal.vue?vue&type=template&id=50517ff0"
import script from "./CaptureModal.vue?vue&type=script&lang=js"
export * from "./CaptureModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__